import { useEffect, useRef, useState } from 'react';
import { UserI } from 'app/utils/userSlice';
import { Icon } from 'app/components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'app/store/store';
import { UserSettingsModal } from 'UserSettingsModal/UserSettingsModal';
import { useLogoutMutation } from 'app/api/auth';
import { useOnClickOutside } from 'app/hooks';

import styles from './UserMenu.module.scss';

type UserT = {
  user: UserI;
};

export const UserMenu = ({ user }: UserT) => {
  const { t, i18n } = useTranslation();

  const [logout] = useLogoutMutation();

  const supportEmail: string = window._env_?.SUPPORT_EMAIL;
  const profile = useAppSelector((state) => state.userSlice.profile);
  const [isUserSettingsModalShown, setIsUserSettingsModalShown] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof profile?.system?.languageTag === 'string') {
      i18n.changeLanguage(profile.system.languageTag);
    }
  }, [profile]);

  const clickOutsideHandler = () => {
    setIsUserSettingsModalShown(false);
  };
  useOnClickOutside(modalRef, clickOutsideHandler);

  const MENU = [
    {
      title: t('Settings'),
      onClick: () => {
        setIsUserSettingsModalShown(true);
      },
      isAvailable: true,
    },
    {
      type: 'icon',
      icon: <Icon name="away-icon" size="11px" color="#979CB4" />,
      to: `mailto:${supportEmail}`,
      title: t('Feedback'),
      isAvailable: true,
      widthDivider: true,
    },

    {
      title: t('Logout'),
      onClick: () => {
        logout(window.location.href)
          .unwrap()
          .then((res) => {
            window.location.replace(res?.value?.logoutUrl);
          });
      },
      isAvailable: true,
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.avatar}>
          <Icon name="user" size="16px" />
        </div>
        <div className={styles.user_name}>{user?.value.preferred_username}</div>
        <Icon name="chevron-down" size="16" />
        <ul className={styles.menu}>
          {/* TODO: Move outside return  */}
          {MENU.map((item, index) => {
            if (item.isAvailable) {
              if (item.type === 'divider') {
                return <li key={index} className={styles.divider} />;
              } else if (item.type === 'icon') {
                return (
                  <li key={index} className={styles.item}>
                    <Link className={styles.item_link} to={item.to || '/'}>
                      {item.title}
                      {item.icon}
                    </Link>
                  </li>
                );
              } else {
                return (
                  <li className={styles.item} key={index} onClick={item.onClick}>
                    {item.title}
                  </li>
                );
              }
            }
          })}
        </ul>
      </div>
      {isUserSettingsModalShown && (
        <UserSettingsModal
          isShown={isUserSettingsModalShown}
          user={user}
          innerRef={modalRef}
          onClose={() => {
            setIsUserSettingsModalShown(false);
          }}
        />
      )}
    </div>
  );
};
